import { Select } from "antd";
import { locale, t } from "../MainApp";
import { ITable } from "../App";
import { TSelectedTable } from "./SingleHallReservation";



type TableSelectorProps = {
    disabled: boolean;

    hasStandingReservations: boolean;
    tables: ITable[];

    selectedTable: TSelectedTable;
    onSelectTableId: (table: number) => void;

    locale: locale;
};

export function TableSelector(props: TableSelectorProps) {

    function buildTables() {
        let elements = [];
        if(props.hasStandingReservations) {
            elements.push(<Select.Option value={0} key={0}>{t(props.locale, "upstraight")}</Select.Option>);
        }

        for (const table of props.tables) {
            elements.push(<Select.Option value={table.id} key={table.id}>{table.name}</Select.Option>)
        }

        return elements;
    }

    return (
        <>            
            <Select
                style={{ width: '100%' }}
                placeholder={t(props.locale, "chooseTable")}
                onChange={(table) => { props.onSelectTableId(table); }}
                value={ props.selectedTable ? props.selectedTable.id : 0 }
                disabled={props.disabled}
            >
                {buildTables()}
            </Select>
        </>
    );
}